import common from './common.json';
import propertyMembers from './property-members.json';

export default {
  common,
  propertyMembers,
};
